import { render, staticRenderFns } from "./Addgood.vue?vue&type=template&id=0acf2938&scoped=true"
import script from "./Addgood.vue?vue&type=script&lang=js"
export * from "./Addgood.vue?vue&type=script&lang=js"
import style0 from "./Addgood.vue?vue&type=style&index=0&id=0acf2938&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acf2938",
  null
  
)

export default component.exports